import { s, type SpacingToken } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

type DetailInfoPanelColumnInset = 'none' | 'start' | 'middle' | 'end';

type DetailInfoPanelColumnOptions = {
  dividerAfter?: boolean;
  dividerWidth?: number;
};

type DetailInfoPanelColumnContentOptions = {
  inset?: DetailInfoPanelColumnInset;
};

export const detailInfoPanelGridGap = 'md' satisfies SpacingToken;

export const detailInfoPanelColumnGridSize = {
  xs: 12,
  sm: 4,
} as const;

export const detailInfoPanelSurfaceSx: SxProps<Theme> = {
  backgroundColor: 'var(--surface-card)',
  '& .flowqa-info-field': {
    gap: s('sm'),
  },
  '& .flowqa-info-field + .flowqa-info-field': {
    marginTop: s('md'),
  },
  '& .flowqa-info-field-label': {
    fontSize: '13px',
    lineHeight: 1.4,
  },
  '& .flowqa-info-field-value': {
    fontSize: '15px',
    lineHeight: 1.4,
  },
};

export const buildDetailInfoPanelColumnSx = ({
  dividerAfter = false,
  dividerWidth = 1,
}: DetailInfoPanelColumnOptions = {}): SxProps<Theme> => {
  if (dividerAfter) {
    return {
      borderRight: dividerWidth,
      borderColor: 'divider',
      display: 'flex',
    };
  }

  return {
    display: 'flex',
  };
};

export const buildDetailInfoPanelColumnContentSx = ({
  inset = 'none',
}: DetailInfoPanelColumnContentOptions = {}): SxProps<Theme> => {
  switch (inset) {
    case 'none':
      return {
        width: '100%',
      };
    case 'start':
      return {
        paddingRight: s('md'),
        width: '100%',
      };
    case 'middle':
      return {
        paddingX: s('md'),
        width: '100%',
      };
    case 'end':
      return {
        paddingLeft: s('md'),
        width: '100%',
      };
    default: {
      const exhaustiveInset: never = inset;
      return exhaustiveInset;
    }
  }
};
